export default el => {
  const triggers = [...document.querySelectorAll('.js-search-mobile-trigger')]

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()
      el.classList.toggle('is-active')

      if (document.querySelector('.instant-search-visible')) {
        document.querySelector('.instant-search-visible').classList.remove('instant-search-visible')
      }
    })
  })
}
